// Wishlist ------------------------------------------------------------------------

function toggleWishlist(event) {
  let pdpData = {};
  const productElement = event.currentTarget.closest('[data-product]');
  if (productElement) {
    pdpData = {
      productTitle: productElement.dataset.title,
      productImg: productElement.dataset.image,
      productPrice: productElement.dataset.price,
      productUrl: productElement.dataset.url,
      productLabel: productElement.dataset.label || '',
    };
  } else {
    console.log('Product element not found.');
    return;
  }

  let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
  const isAlreadyInWishlist = wishlistData.some((item) => item.productTitle === pdpData.productTitle);

  if (!isAlreadyInWishlist) {
    wishlistData.push(pdpData);
    localStorage.setItem('wishlist', JSON.stringify(wishlistData));

    // Redirect to wishlist page
    window.location.href = '/pages/wishlist';
  } else {
    // Already in wishlist, optionally still redirect
    window.location.href = '/pages/wishlist';
  }

  displayWishlist();
}

function removeFromWishlist(productTitle) {
  let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
  wishlistData = wishlistData.filter((item) => item.productTitle !== productTitle);
  localStorage.setItem('wishlist', JSON.stringify(wishlistData));
  displayWishlist();
}

function displayWishlist() {
  const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
  const wishlistBlock = document.querySelector('.js-wishlistBlock');

  if (!wishlistBlock) {
    console.log('Element with class "js-wishlistBlock" not found');
    return;
  }

  if (wishlistData.length === 0) {
    wishlistBlock.innerHTML = '<p>Your wishlist is empty.</p>';
    return;
  }

  const wishlistHtml = wishlistData
    .map(
      (item) => `
      <div class="wishlist-product__list c-product">
        <div class="wishlist-product">
          <a href="${item.productUrl}">
            <img src="${item.productImg}" alt="${item.productTitle}">
          </a>
          <h3 class="c-product__title card__heading h5">
            <a class="full-unstyled-link" href="${item.productUrl}">${item.productTitle}</a>
          </h3>
          <p class="product-price price-item" data-base-price="${item.productPrice.replace(/[^0-9.]/g, '')}">${
        item.productPrice
      }</p>
          ${item.productLabel ? `<span class="product-label badge">${item.productLabel}</span>` : ''}
          <button class="wishlist-page-button" onclick="removeFromWishlist('${item.productTitle}')">Remove</button>
        </div>
      </div>
    `
    )
    .join('');

  wishlistBlock.innerHTML = wishlistHtml;

  const savedCurrency = localStorage.getItem('selectedCurrency');
  if (savedCurrency) {
    updatePrices(savedCurrency);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  displayWishlist();
});

document.addEventListener('click', function () {
  setTimeout(() => {
    const savedCurrency = localStorage.getItem('selectedCurrency');
    if (savedCurrency) {
      updatePrices(savedCurrency);
    }
  }, 2000);
});

// Currency ----------------------------------------------------------

const BASE_CURRENCY = 'usd';
const CURRENCIES = ['usd', 'gbp', 'eur', 'cad', 'nzd', 'sar', 'qar', 'jpy', 'zar', 'aud'];

let selectedCurrencyText = document.querySelector(".selected-currency");
let currencyOptions = document.querySelector("#drawerSelectedCurrency");
let currencyOptions2 = document.querySelector("#drawerSelectedCurrency2");

let currencyFooterOptions = document.querySelector("#drawerFooterSelectedCurrency");

// Load saved currency on page load
// const savedCurrency = localStorage.getItem("selectedCurrency");
// if (savedCurrency) {
//   let matchedOption = document.querySelector(`#currency-buttons li[data-currency="${savedCurrency}"]`);
//   console.log(savedCurrency);
//   if (matchedOption) {
//     let currencyFlag = matchedOption.querySelector("span").innerHTML;
//     selectedCurrencyText.innerHTML = currencyFlag; // insert SVG directly
//   }
// }

// Handle clicks

async function fetchExchangeRates() {
  const url = `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/${BASE_CURRENCY}.json`;

  try {
    const res = await fetch(url);
    const data = await res.json();

    if (data[BASE_CURRENCY]) {
      document.getElementById('exchange-rates').dataset.rates = JSON.stringify(data[BASE_CURRENCY]);
      applySavedCurrency();
    }
  } catch (error) {
    console.log('Error fetching exchange rates:', error);
  }
}

function convertPrice(originalPrice, targetCurrency) {
  const rates = JSON.parse(document.getElementById('exchange-rates').dataset.rates || '{}');
  const rate = rates[targetCurrency];
  if (!rate) return originalPrice;
 return Math.round(originalPrice * rate).toLocaleString();
}


function updatePrices(currency) {
  document.querySelectorAll('.price-item').forEach((el) => {
    const basePrice = parseFloat(el.dataset.basePrice);
    let currencySymbol;
    if (currency.toUpperCase() == 'USD') {
      currencySymbol = '$';
    } else if (currency.toUpperCase() == 'GBP') {
      currencySymbol = '£';
    } else if (currency.toUpperCase() == 'EUR') {
      currencySymbol = '€';
    } else if (currency.toUpperCase() == 'JPY') {
      currencySymbol = '¥';
    } else {
      currencySymbol = currency.toUpperCase();
    }
    el.textContent = `${currencySymbol} ${convertPrice(basePrice, currency)}`;
    document.querySelectorAll('.selected-currency').forEach(selectedCurrency => {
      selectedCurrency.textContent = currency.toUpperCase();
    });
  });
}
function applySavedCurrency() {
  let GEO_CURRENCY = 'usd';
  fetch("https://ipwhois.app/json/")
  .then(res => res.json())
  .then(data => {
    const countryCode = data.country_code.toLowerCase(); 
    // Map some country codes to currencies if needed
    const countryCurrencyMap = {
      'us': 'usd',
      'gb': 'gbp',
      'eu': 'eur',
      'ca': 'cad',
      'nz': 'nzd',
      'sa': 'sar',
      'qa': 'qar',
      'jp': 'jpy',
      'za': 'zar',
      'au': 'aud'
    };
    const currency = countryCurrencyMap[countryCode];
    if (currency && CURRENCIES.includes(currency)) {
      GEO_CURRENCY = currency;
    } else {
      GEO_CURRENCY = 'usd'; // fallback
    }
    const savedCurrency = localStorage.getItem('selectedCurrency');

    if (!savedCurrency) {
      let matchedOption = document.querySelector(`#currency-buttons li[data-currency="${GEO_CURRENCY}"] span svg`);
      localStorage.setItem('selectedCurrencyFlag' ,  matchedOption.outerHTML);
      localStorage.setItem('selectedCurrency', GEO_CURRENCY )
    }
  })
  .catch(err => {
    console.error(err);
    GEO_CURRENCY = 'usd'; // fallback on error
  });
  const savedCurrency = localStorage.getItem('selectedCurrency');
  if (savedCurrency && CURRENCIES.includes(savedCurrency)) {
    updatePrices(savedCurrency);
  }
}
// function applySavedCurrency() {
//   const savedCurrency = localStorage.getItem('selectedCurrency');
//   if (savedCurrency && CURRENCIES.includes(savedCurrency)) {
//     updatePrices(savedCurrency);
//   }
// }

// On currency button click
document.querySelectorAll('#currency-buttons li').forEach((btn) => {
  btn.addEventListener('click', () => {
    const selectedCurrency = btn.dataset.currency;
    localStorage.setItem('selectedCurrency', selectedCurrency);
    let matchedOption = document.querySelector(`#currency-buttons li[data-currency="${selectedCurrency}"] span svg`);
    localStorage.setItem('selectedCurrencyFlag' ,  matchedOption.outerHTML);

    updatePrices(selectedCurrency);
    const mainBody = document.querySelector('body');
    const closeCurDrawer = document.getElementById('drawer');
    const closeMenuDrawer = document.getElementById('Details-menu-drawer-container-custom');
    const menuDrawerSum = closeMenuDrawer.querySelector("summary[aria-label='Menu']");
    currencyOptions.innerHTML = matchedOption.outerHTML;
    currencyOptions2.innerHTML = matchedOption.outerHTML; 
    currencyFooterOptions.innerHTML = matchedOption.outerHTML;

    closeCurDrawer.classList.remove('open');
    mainBody.classList.remove('overflow-hidden-desktop');
    closeMenuDrawer.removeAttribute('open');
    menuDrawerSum.setAttribute('aria-expanded', 'false');
  });
});

let matchedOption = localStorage.getItem('selectedCurrencyFlag');
if(matchedOption){
  currencyOptions.innerHTML = matchedOption;
  currencyOptions2.innerHTML = matchedOption;
  currencyFooterOptions.innerHTML = matchedOption;
}

// Init
fetchExchangeRates();

// Color Filter -----------------------------------------------------------------

// GLOBAL STATES

let currentColorFilter = [];
let isInfiniteLoading = false;
let hasMorePages = true;


// LOAD SAVED COLORS

function loadSavedColors() {
  const saved = JSON.parse(localStorage.getItem("selectedColors") || "[]");
  if (saved.length === 0) return;

  currentColorFilter = saved;

  saved.forEach(color => {
    const btn = document.querySelector(`[data-color="${color}"]`);
    if (btn) btn.classList.add("active");
  });

  filterProductsByColor(saved);
}


// FILTER PRODUCTS

function filterProductsByColor(selectedColors) {
  hideNoProductsMessage();

  
  selectedColors.forEach(selectedColor => {
    const selectedColorFilter = document.querySelector(".active-facets.active-facets-mobile");

    if (selectedColorFilter) {
      
      const capitalName = selectedColor.charAt(0).toUpperCase() + selectedColor.slice(1).toLowerCase();

      // CHECK — already exists? (case-insensitive)
      const exists = [...selectedColorFilter.querySelectorAll(".active-facets__button-inner")]
        .some(el => el.textContent.trim().toLowerCase().includes(`color: ${selectedColor.toLowerCase()}`));

      if (exists) {
        console.log(`"${capitalName}" already exists, not adding again.`);
        return; // STOP — do not add again
      }

      const currentUrl = window.location.href;

      // Create element only if NOT exists
      const wrapper = document.createElement("facet-remove");
      wrapper.innerHTML = `
        <a href="${currentUrl}" class="active-facets__button active-facets__button--light" role="button">
          <span class="active-facets__button-inner button button--tertiary">
            Color: ${capitalName}
            <span class="svg-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"></path>
              </svg>
            </span>
            <span class="visually-hidden">Remove filter</span>
          </span>
        </a>
      `;
      wrapper.classList.add("custom-active-color");

      // Add at top
      selectedColorFilter.prepend(wrapper);
    }
  });

  const productCards = document.querySelectorAll(".grid__item");

  productCards.forEach(card => {
    setTimeout(() => {
      const swatches = card.querySelectorAll("[data-value]");

      let hasColor = false;
      swatches.forEach(swatch => {
        const swatchColor = swatch.getAttribute("data-value")?.toLowerCase();
        if (
          selectedColors.includes(swatchColor) &&
          swatch.getAttribute("current-product") === "true"
        ) {
          hasColor = true;
        }
      });

      card.style.display = hasColor ? "" : "none";
    }, 1000);
  });

  applySavedCurrencyAfterFilter();

  evaluateNoProducts();
}


// EVALUATE NO PRODUCTS (SAFE)

function evaluateNoProducts() {
  if (isInfiniteLoading || hasMorePages) return;

  const visibleProducts = document.querySelectorAll(
    ".grid__item:not([style*='display: none'])"
  ).length;

  showNoProductsMessage(
    visibleProducts === 0,
    currentColorFilter.join(", ")
  );
}


// NO PRODUCTS MESSAGE

function showNoProductsMessage(show, color) {
  let messageEl = document.getElementById("no-products-message");

  if (show && !messageEl) {
    messageEl = document.createElement("div");
    messageEl.id = "no-products-message";
    messageEl.style.textAlign = "center";
    messageEl.style.padding = "2rem";
    messageEl.style.color = "#666";
    messageEl.innerHTML = `No products found for color: <strong>${color}</strong>`;

    const grid =
      document.querySelector(".grid") ||
      document.querySelector(".product-grid");

    if (grid) grid.appendChild(messageEl);
  } else if (!show && messageEl) {
    messageEl.remove();
  }
}

function hideNoProductsMessage() {
  const messageEl = document.getElementById("no-products-message");
  if (messageEl) messageEl.remove();
}


// SHOW ALL PRODUCTS

function showAllProducts() {
  document.querySelectorAll(".grid__item").forEach(card => {
    card.style.display = "";
  });
  hideNoProductsMessage();
}


// INFINITE SCROLL OBSERVER

function setupInfiniteScrollObserver() {
  const observer = new MutationObserver(mutations => {
    let newProductsAdded = false;

    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (
          node.nodeType === 1 &&
          (node.classList?.contains("grid__item") ||
            node.querySelector?.(".grid__item"))
        ) {
          newProductsAdded = true;
          isInfiniteLoading = true;
        }
      });
    });

    if (newProductsAdded) {
      setTimeout(() => {
        if (currentColorFilter.length > 0) {
          filterProductsByColor(currentColorFilter);
        }
        applySavedCurrencyAfterFilter();
        checkInfiniteEnd();
      }, 100);
    }
  });

  const productsContainer =
    document.querySelector(".grid") ||
    document.querySelector(".product-grid") ||
    document.querySelector(".collection");

  if (productsContainer) {
    observer.observe(productsContainer, { childList: true, subtree: true });
  }
}


// CHECK LAST PAGE

function checkInfiniteEnd() {
  // clear previous timer
  if (infiniteEndTimer) {
    clearTimeout(infiniteEndTimer);
  }

  // delay check (VERY IMPORTANT)
  infiniteEndTimer = setTimeout(() => {
    const nextBtn = document.querySelector(".pagination__next");

    if (!nextBtn) {
      hasMorePages = false;
      isInfiniteLoading = false;
      evaluateNoProducts();
    } else {
      // still pages left
      hasMorePages = true;
      isInfiniteLoading = false;
    }
  }, 1000); // delay so infinite scroll can inject next page
}


// COLOR BUTTON HANDLERS

function initializeColorFilters() {
  const colorButtons = document.querySelectorAll(".color-filter-option");

  colorButtons.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const selectedColor = this.dataset.color;

      if (currentColorFilter.includes(selectedColor)) {
        currentColorFilter = currentColorFilter.filter(c => c !== selectedColor);
        this.classList.remove("active");
      } else {
        currentColorFilter.push(selectedColor);
        this.classList.add("active");
      }

      localStorage.setItem("selectedColors", JSON.stringify(currentColorFilter));
    });
  });

  const applyBtn = document.querySelector(".apply-filters-btn");
  if (applyBtn) {
    applyBtn.addEventListener("click", e => {
      e.preventDefault();
      if (currentColorFilter.length === 0) {
        showAllProducts();
      } else {
        window.location.reload();
      }
    });
  }
}


// FILTER OBSERVER (SAFE)

function setupFilterObserver() {
  const filterContainer = document.querySelector(".filter-container");
  if (!filterContainer) return;

  const observer = new MutationObserver(() => {
    initializeColorFilters();
  });

  observer.observe(filterContainer, { childList: true, subtree: true });
}


// INIT

document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (path.includes("/search") || path.includes("/collections")) {
    // console.log("test")
    loadSavedColors();
    initializeColorFilters();
    setupInfiniteScrollObserver();
    setupFilterObserver();

    applySavedCurrencyAfterFilter();
  }
});

function applySavedCurrencyAfterFilter() {
  const savedCurrency = localStorage.getItem('selectedCurrency');
  if (savedCurrency && CURRENCIES.includes(savedCurrency)) {
    updatePrices(savedCurrency);
  }
}

// custom filter button & filter selected tabs handling

const mobileMenuClose = document.querySelector(".menu-drawer__navigationMobile .header__icon");
mobileMenuClose.addEventListener('click', () => {
  document.querySelector('body').classList.remove('overflow-hidden-desktop');
});

let selectedHref = null;

document.querySelectorAll(".mobile-facets__list-custom .mobile-facets__label")
  .forEach(filterBtn => {
    filterBtn.addEventListener("click", function (e) {
      e.preventDefault();

      // const label = this.querySelector('.mobile-facets__label');
      const isActive = this.classList.contains("active");

      // If already active → remove
      if (isActive) {
        this.classList.remove("active");
        selectedHref = null;
        return;
      }

      // Remove all active labels
      document.querySelectorAll(".mobile-facets__list-custom .mobile-facets__label.active")
        .forEach(activeBtn => activeBtn.classList.remove("active"));

      // Add active to clicked one
      this.classList.add("active");

      // Save selected collection href
      selectedHref = this.getAttribute("href");
    });
  });

document.addEventListener("click", (e) => {
  if (e.target.classList.contains("apply-filters-btn")) {
    e.preventDefault();

    const form = document.querySelector("facet-filters-form form");
    const facetClass = document.querySelector("facet-filters-form");

    let finalURL = null;

    if (form && facetClass) {
      // Shopify filter params
      const searchParams = facetClass.createSearchParams(form);
      const facetQuery = searchParams.toString(); // removes the "?"

      // If collection selected
      if (selectedHref) {
        if (facetQuery) {
          finalURL = `${selectedHref}?${facetQuery}`;
        } else {
          finalURL = selectedHref;
        }
      } 
      else {
        // No collection, only facet filters
        if (facetQuery) {
          finalURL = `?${facetQuery}`;
        }
      }

      // If we built a final URL → go to it
      if (finalURL) {
        window.location.href = finalURL;
        return;
      }

      // Else → fallback Shopify submit (no collection + empty filters)
      facetClass.onSubmitForm(searchParams, e);
    }
  }
});


function activateCollectionTabOnLoad() {
  const currentURL = window.location.pathname.toLowerCase();

  const tabs = document.querySelectorAll(".mobile-facets__list-custom .mobile-facets__label"); // <-- apne tab ka class yahan likho

  tabs.forEach(tab => {
    const tabURL = tab.getAttribute("href")?.toLowerCase();

    if (tabURL && currentURL.includes(tabURL)) {
      tab.classList.add("active");
    } else {
      tab.classList.remove("active");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  activateCollectionTabOnLoad();
});


document.addEventListener("DOMContentLoaded", function () {
  const sortTabs = document.querySelectorAll(".sort-tab");

  sortTabs.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      const selectedSort = this.value;

      // Get current real URL (with all filters)
      const url = new URL(window.location.href);

      // Add OR update sort_by param
      url.searchParams.set("sort_by", selectedSort);

      // Redirect to updated URL (filters remain safe)
      window.location.href = url.toString();
    });
  });
});

document.addEventListener("click", function (e) {
  const btn = e.target.closest("facet-remove.custom-active-color");

  if (btn) {
    e.preventDefault();

    const innerSpan = btn.querySelector(".active-facets__button-inner");
    if (!innerSpan) return;

    // Option: Split by line break
    const fullText = innerSpan.innerText.trim();
    const colorToRemove = fullText
      .replace("Color:", "")
      .split("\n")[0] 
      .trim()
      .toLowerCase();

    console.log(colorToRemove);

    // remove color from localStorage array
    let storedColors = JSON.parse(localStorage.getItem("selectedColors")) || [];
    const updatedArray = storedColors.filter(color => color.toLowerCase() !== colorToRemove);

    localStorage.setItem("selectedColors", JSON.stringify(updatedArray));

    console.log("Updated Colors:", updatedArray);

    // REMOVE the UI button itself
    btn.remove();

    // Reload the page
    window.location.reload();
  }
  const removeBtn = e.target.closest(".active-facets__button-remove");
  if(removeBtn){
    localStorage.removeItem("selectedColors");
    setTimeout(() => {
      // Reload the page
      window.location.reload();
    }, 1000);
  }
  const drawerRemoveBtn = e.target.closest("facet-remove .mobile-facets__clear");
  if(drawerRemoveBtn){
    localStorage.removeItem("selectedColors");
    setTimeout(() => {
      // Reload the page
      window.location.reload();
    }, 1000);
  }
  const normalFacetBtn = e.target.closest("facet-remove:not(.custom-active-color)");
  if(normalFacetBtn){
    setTimeout(() => {
      // Reload the page
      window.location.reload();
    }, 1000);
  }
});

// custom infinite scroll

document.addEventListener("DOMContentLoaded", () => {
  let page = 1;
  let isLoading = false;
  let hasMore = true;

  const grid =
    document.querySelector(".grid") ||
    document.querySelector(".product-grid");

  const loader = document.getElementById("infinite-loader");

  if (!grid) return;

  async function loadMoreProducts() {
    if (isLoading || !hasMore) return;

    isLoading = true;
    loader.style.display = "block";
    page++;

    // Preserve ALL existing filters
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.set("page", page);

    try {
      const res = await fetch(urlObj.toString());
      if (!res.ok) throw new Error("No more pages");

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newProducts = doc.querySelectorAll(
        ".product-grid .grid__item"
      );

      if (!newProducts.length) {
        hasMore = false;
        return;
      }

      newProducts.forEach(item => grid.appendChild(item));

      // Re-apply ONLY custom JS logic
      if (window.currentColorFilter?.length) {
        filterProductsByColor(currentColorFilter);
      }

      applySavedCurrencyAfterFilter?.();

    } catch (e) {
      hasMore = false;
    } finally {
      isLoading = false;
      loader.style.display = "none";
    }
  }

  window.addEventListener("scroll", () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 300
    ) {
      loadMoreProducts();
    }
  });
});


// scroll on color filter applied

scrollDownIfColorFilterApplied = () => {
  setTimeout(() => {
    window.scrollTo({ top: 200, behavior: "smooth" });
  }, 2000);
};

document.addEventListener("DOMContentLoaded", () => {
  let customActiveColors = document.querySelectorAll(".custom-active-color");
  if (customActiveColors.length > 0) {
    scrollDownIfColorFilterApplied();
  }
});
